import * as Sentry from "@sentry/browser";
import { LOGIN_SUCCESS, LOGOUT_REQUEST } from "./constants/actionTypes";

export const initMonitoring = () => {
  if (process.env.REACT_APP_GLITCHTIP_ENABLED !== "true") return;

  Sentry.init({
    dsn: process.env.REACT_APP_GLITCHTIP_DSN,
    tunnel: `${process.env.REACT_APP_RECARGA_API_URL}/monitoring/envelope`,
    environment: process.env.REACT_APP_NODE_ENV,
    release: process.env.REACT_APP_VERSION || "dev",
    autoSessionTracking: false, // GlitchTip não suporta session tracking
  });
};

export const monitoringMiddleware = store => next => action => {
  const result = next(action);

  if (action.type === LOGIN_SUCCESS || action.type === LOGOUT_REQUEST) {
    const { identifier } = store.getState().sessionState;
    Sentry.setTag("msisdn", identifier || undefined);
  }

  return result;
};
